enum FileType {
    AppLogo = 'applogo',
    DocImage = 'docimg'
}

export default FileType;